'use client';

import { create } from 'zustand';

const JUST_CLAIMED_TTL_MS = 8000;

interface ClaimSheetState {
  isOpen: boolean;
  justClaimed: ReadonlySet<string>;
  open: () => void;
  close: () => void;
  markJustClaimed: (keys: string[]) => void;
  clearJustClaimed: () => void;
}

let clearTimer: ReturnType<typeof setTimeout> | undefined;

export const useClaimSheetStore = create<ClaimSheetState>((set) => ({
  isOpen: false,
  justClaimed: new Set<string>(),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  markJustClaimed: (keys) => {
    clearTimeout(clearTimer);
    set({ justClaimed: new Set(keys) });
    clearTimer = setTimeout(() => set({ justClaimed: new Set<string>() }), JUST_CLAIMED_TTL_MS);
  },
  clearJustClaimed: () => {
    clearTimeout(clearTimer);
    set({ justClaimed: new Set<string>() });
  },
}));

export const useOpenClaimSheet = () => useClaimSheetStore((s) => s.open);
